import { IncentivationDataType } from "./incentivationDataType";

export enum RewardCalculationType {
    DefinedBySubtypeCalculationType = "DefinedBySubtypeCalculationType",
    ManualInputCalculationType = "ManualInputCalculationType",
    MaxPointsCalculationType = "MaxPointsCalculationType",
    PercentMaxPointsCalculationType = "PercentMaxPointsCalculationType",
    SplitMaxPointsCalculationType = "SplitMaxPointsCalculationType",
    ScoreRangeCalculationType = "ScoreRangeCalculationType",
};


export interface BaseRewardCalculationType {
    type: RewardCalculationType;
    expectedIncentivationDataType: IncentivationDataType;
};

export interface ScoreRangeRewardCalculationType extends BaseRewardCalculationType {
    scoreRanges: ScoreRange[]
};

export interface ScoreRange {
    scoreFrom: number;
    scoreTo: number;
    pointsRewarded: number;
};
